/**
 * `/_/panel`: the door panel of a room (F-79 phase 1C). Public, no session, no app shell. The device's token
 * arrives once in the fragment (`#t=...`) and is kept in `localStorage` by the page.
 */
export const ROOM_PANEL_PATH = '/_/panel'

export const isRoomPanelPath = (path: string): boolean => path === ROOM_PANEL_PATH || path === `${ROOM_PANEL_PATH}/`

/**
 * `/_/bookings/new?resourceId=&start=&duration=`: where the panel's QR lands. It needs a session and opens
 * the normal booking dialog already filled in.
 */
export const BOOKING_NEW_PATH = '/_/bookings/new'

export const isBookingNewPath = (path: string): boolean => path === BOOKING_NEW_PATH || path === `${BOOKING_NEW_PATH}/`
